export function PayableAmount({ product }) {
	const splitedItems = product?.item_number?.options?.recurring?.times || 0;

	return (
		<>
			<div className="wp-checkout-flex .wp-checkout-flex-center wp-checkout-flex-space-between  wp-checkout-payable-amount">
				<div className="wp-checkout-payable-amount-header">
					<h4 className="wp-checkout-font-lg">Total Amount</h4>
				</div>
				<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-payable-amount-value">
					<span className="wp-checkout-font-lg">
						${(+product.item_price)?.toFixed(2)}
					</span>
					<span className="wp-checkout-font-sm  wp-checkout-lowlight-text">
						/month
					</span>
				</div>
			</div>
			<p className="wp-checkout-font-sm wp-checkout-note">
				{' '}
				<span className="wp-checkout-highlight-text">Note:</span> You
				will be charged{' '}
				<span className="wp-checkout-highlight-text">
					${(+product.price)?.toFixed(2)}/month
				</span>{' '}
				for next <span>{splitedItems} months.</span>
			</p>
		</>
	);
}
